module.exports = __webpack_public_path__ + "img/display_image.3eaccb26.jpg";